import { useTranslation } from "react-i18next";
import LegalLayout from "@/components/LegalLayout";

const sections = [
  {
    id: "acceptance",
    title: "Acceptance of terms",
    body: [
      "By creating an Instantxfer CashApp account, accessing our website at www.instantxfer.com, or using any Instantxfer CashApp service (the 'Service'), you agree to these Terms of Service. If you do not agree, do not use the Service.",
      "Instantxfer CashApp Financial Technologies B.V. ('Instantxfer CashApp', 'we', 'us') operates the Service in partnership with licensed money-service businesses in each corridor.",
    ],
  },
  {
    id: "eligibility",
    title: "Eligibility",
    body: [
      "You must be at least 18 years old and legally able to enter contracts in your jurisdiction. You must not be on any sanctions list maintained by the UN, EU, UK, US or the country of your residence.",
      "Business accounts require valid corporate documentation, disclosure of beneficial owners of 25% or more, and completion of enhanced due diligence.",
    ],
  },
  {
    id: "kyc",
    title: "Identity verification",
    body: [
      "You authorise Instantxfer CashApp and our verification partners to collect and verify your identity information, including government-issued ID and biometric data used solely for the liveness check.",
      "We may request additional information at any time to satisfy our AML, CTF and sanctions obligations.",
    ],
  },
  {
    id: "transfers",
    title: "Sending money",
    body: [
      "Transfer fees, exchange rates, and expected delivery times are shown before you confirm a send. Once you tap send, the quote is locked for 60 seconds and settled at the quoted mid-market rate.",
      "Transfer limits vary by corridor, verification level, and applicable regulation. Some corridors carry small agent fees for cash pickup, which are disclosed on the ticket.",
      "You are responsible for the accuracy of recipient details. Instantxfer CashApp is not liable for funds sent to an incorrectly entered account.",
    ],
  },
  {
    id: "prohibited",
    title: "Prohibited uses",
    body: [
      "You may not use Instantxfer CashApp to fund gambling, weapons, adult services, narcotics, terrorism, sanctioned entities, or any activity that violates the laws of the sending or receiving country.",
      "We reserve the right to pause, review, or reverse any transfer we reasonably suspect of breaching this section.",
    ],
  },
  {
    id: "fees",
    title: "Fees",
    body: [
      "Instantxfer CashApp charges 0.9% of the send amount as our platform fee. Some corridors carry additional agent or partner fees that are always disclosed on the quote screen.",
      "We do not add a spread to the mid-market exchange rate.",
    ],
  },
  {
    id: "liability",
    title: "Limitation of liability",
    body: [
      "To the maximum extent permitted by law, Instantxfer CashApp's aggregate liability for any claim arising out of the Service is limited to the total fees you paid us in the twelve months prior to the claim.",
      "We are not liable for indirect, consequential, or incidental damages.",
    ],
  },
  {
    id: "termination",
    title: "Suspension and termination",
    body: [
      "We may suspend or terminate your account if you breach these Terms, if required by law, or if we detect activity that puts your funds, other users, or our licences at risk.",
      "You may close your account at any time from the app. Any funds remaining after fees and reserves will be returned to your source of funds.",
    ],
  },
  {
    id: "law",
    title: "Governing law",
    body: [
      "These Terms are governed by the laws of the Netherlands. Disputes will be resolved by the competent courts in Amsterdam, without prejudice to your mandatory consumer rights in your country of residence.",
    ],
  },
];

export default function Terms() {
  const { t } = useTranslation();
  return (
    <LegalLayout
      eyebrow={t("pageHero.terms.eyebrow")}
      title={t("pageHero.terms.title")}
      updated="December 2025"
      sections={sections}
      testId="terms-page"
    />
  );
}
